import Vue from "vue";
import Api from "./api";

export const $ = (selector, from = document) => from.querySelector(selector);

export const $$ = (selector, from = document) => [...from.querySelectorAll(selector)];

export const bus = new Vue();

export const asCleanString = value =>
  String(value)
    .trim()
    .toLocaleLowerCase();

export const api = new Api({
  skip_csrf: Number(process.env.VUE_APP_WITH_CSRF) === 0,
});

/**
 *
 * @link https://stackoverflow.com/a/42956086/605707
 */
export const slotText = children => {
  if (!children) {
    return "";
  }

  return children
    .map(function(node) {
      return node.children ? slotText(node.children) : node.text;
    })
    .join("")
    .trim();
};
